export class DtmUserInfo {
  userId: string;
  businessId: string;
  clientId: string;

  constructor(userInfoData: any) {
    let logon = sessionStorage.getItem('logon');
    if (logon) {
      this.userId = logon;
    }else{
      this.userId = userInfoData.userId
    }
    this.businessId = userInfoData.businessId;
    this.clientId = userInfoData.clientId;
  }
}
